import { TeamsFxContext } from 'src/context/TeamsContext';
import {
  RequiredHours,
  TableRowFooterCell,
} from './styles/TimesheetsTableFooter.styled';
import { useContext } from 'react';

interface TimesheetsTableFooterProps {
  data: string;
  dayForecastedHours?: number;
  dayForcastedType?: number;
  index?: number;

  isDataCell?: boolean;
}

export const TimesheetsTableFooter = ({
  data,
  dayForecastedHours,
  dayForcastedType,
  index,
  isDataCell,
}: TimesheetsTableFooterProps) => {
  const { isMobile } = useContext(TeamsFxContext);
  return (
    <TableRowFooterCell
      firstRow={index === 0}
      isMobile={isMobile}
      isDataCell={isDataCell}
    >
      <RequiredHours
        isRequiredHour={
          dayForcastedType === 100000000 && dayForecastedHours > 0
        }
        status={Number(data) >= dayForecastedHours}
      />
      {data}
    </TableRowFooterCell>
  );
};
